import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { SocketProvider } from "./context/SocketContext";
import { createGlobalStyle } from "styled-components";
import ErrorBoundary from "./components/ErrorBoundary";
import { initFirebase } from "./api/firebase";
import { AuthProvider } from "./context/AuthContext";
import { cssVariables } from "./theme/css-variables";

const DefaultStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  :root {
    ${cssVariables}
  }

  html {
    height: 100%;
    height: -webkit-fill-available;
    background: linear-gradient(135deg, #1a1b35 0%, #131b3c 100%);
  }

  body {
    font-size: 100%;
    font-family: var(--fontFamily);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
    min-height: 100vh;
    color: rgba(255, 255, 255, 0.9);
    background: 
      linear-gradient(135deg, rgba(89, 44, 166, 0.07) 0%, rgba(66, 33, 123, 0.07) 100%),
      linear-gradient(to bottom, rgba(26, 27, 53, 0.9), rgba(19, 27, 60, 0.9)),
      repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.03) 0px, rgba(255, 255, 255, 0.03) 1px, transparent 1px, transparent 12px),
      repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0px, rgba(255, 255, 255, 0.03) 1px, transparent 1px, transparent 12px);
    background-attachment: fixed;
    overflow-y: auto;
    overflow-x: hidden;
  }

  body::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: radial-gradient(circle at 50% 0%, rgba(89, 44, 166, 0.15), transparent 70%);
    z-index: 1;
  }

  #root {
    position: relative;
    z-index: 2;
  }
`;

async function main() {
  await initFirebase();

  ReactDOM.render(
    <React.StrictMode>
      <AuthProvider>
        <SocketProvider>
          <DefaultStyle />
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </SocketProvider>
      </AuthProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

main();
